import * as React from "react";
import { useTheme } from "@mui/material/styles";
import { Box, Grid } from "@mui/material";

export default function MultipleChoiceImageMultiple({
	question,
	onAnswer = () => {},
}) {
	const theme = useTheme();
	const [selectedAnswers, setSelectedAnswers] = React.useState([]);

	React.useEffect(() => {
		setSelectedAnswers([]);
	}, []);

	const handleSetAnswer = (index) => {
		const currentIndex = selectedAnswers.indexOf(index);
		const newSelectedAnswers = [...selectedAnswers];

		if (currentIndex === -1) {
			newSelectedAnswers.push(index);
		} else {
			newSelectedAnswers.splice(currentIndex, 1);
		}

		setSelectedAnswers(newSelectedAnswers);

		const selectedValues = newSelectedAnswers.map((i) =>
			question.questionList[i].value.trim()
		);

		onAnswer({
			canProceed: newSelectedAnswers.length > 0,
			answer: selectedValues,
		});
	};

	return (
		<React.Fragment>
			<Box
				className="choices-container"
				sx={{ px: 4, textAlign: "center" }}
			>
				{question.questionList && question.questionList.length > 0 ? (
					<Grid
						container
						spacing={2}
						sx={{ mt: 2, justifyContent: "center" }}
					>
						{question.questionList.map((choice, index) => (
							<Grid
								item
								sm={6}
								sx={{
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
								}}
								key={`choice-${index}`}
								onClick={() => handleSetAnswer(index)}
							>
								<Box
									sx={{
										display: "flex",
										backgroundColor: "white",
										justifyContent: "center",
										alignItems: "center",
										flexDirection: "column",
										cursor: "pointer",
										border: selectedAnswers.includes(index)
											? `2px solid ${theme.palette.primary.main}`
											: "2px solid transparent",
										borderRadius: "8px",
										padding: "0.5rem",
									}}
								>
									<img
										src={choice.image}
										alt={choice.value}
										style={{
											width: "8rem",
											height: "7rem",
											objectFit: "contain",
										}}
									/>
								</Box>
							</Grid>
						))}
					</Grid>
				) : (
					<div>No questions available</div>
				)}
			</Box>
		</React.Fragment>
	);
}
